import React, { Fragment, useState } from "react";
import {
  EuiInMemoryTable,
  EuiSpacer,
  EuiButtonIcon,
  EuiHealth,
} from "@elastic/eui";
import { useEffect } from "react";
import OrganizationService from "../../services/organization-service";
import {
  EuiBadge,
  EuiModal,
  EuiModalHeader,
  EuiModalBody,
  EuiButton,
  EuiModalFooter,
} from "@elastic/eui";
import DomainCreate from "./DomainCreate";
import DomainValidate from "./DomainValidate";

const DomainsTable = (props) => {
  const [domains, setDomains] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalLicenses, setModalLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isClosed, setIsClosed] = useState(true);

  const showModal = (licenses) => {
    setIsModalVisible(true);
    setModalLicenses(licenses);
  };

  const renderBadgeIsDefault = (isDefault) => {
    if (isDefault) {
      return <EuiHealth color="success"></EuiHealth>;
    } else {
      return <EuiHealth color="danger"></EuiHealth>;
    }
  };

  const renderBadgeIsVerified = (item) => {
    if (item.isVerified) {
      return <EuiHealth color="success"></EuiHealth>;
    } else {
      return (
        <>
          <EuiHealth color="danger"></EuiHealth> &nbsp;
          <DomainValidate
            domainName={item.id}
            props={props}
            closeModalProp={toggleIsClosed}
          />
        </>
      );
    }
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const toggleIsClosed = () => setIsClosed((prevState) => !prevState);

  const renderModal = () => {
    return (
      <EuiModal onClose={closeModal} style={{ width: "800px" }}>
        <EuiModalHeader>
          <h1>
            <b>Assigned Licenses</b>
          </h1>
        </EuiModalHeader>
        <EuiModalBody>
          {modalLicenses.map((license, index) => (
            <div>
              <EuiBadge color={"#d83b01"} key={index}>
                {license}
              </EuiBadge>
              <EuiSpacer size="xs" />
            </div>
          ))}
        </EuiModalBody>
        <EuiModalFooter>
          <EuiButton onClick={closeModal}>Close</EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  };

  useEffect(() => {
    setDomains([]);
    setLoading(true);
    const organizationId = props.data.company;
    const token = sessionStorage.getItem("krakenT");
    OrganizationService.getMsDomainsByGraph({ token, organizationId })
      .then(({ data: { data: domains } }) => {
        setDomains(domains);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [props, isClosed]);

  //   const extensionClicked = (item) => {
  //     console.log(item);
  //     props.setEditData(item);
  //     props.openFlyoutEdit();
  //   };

  //   const actions = [
  //     {
  //       name: "Edit",
  //       description: "Click here to edit user",
  //       icon: "documentEdit",
  //       type: "icon",
  //       onClick: (item) => extensionClicked(item),
  //     },
  //   ];

  const columns = [
    {
      field: "id",
      name: "id",
      sortable: true,
      truncateText: true,
    },
    {
      field: "isDefault",
      name: "isDefault",
      sortable: true,
      render: (item) => renderBadgeIsDefault(item),
      truncateText: true,
    },
    {
      name: "isVerified",
      sortable: true,
      render: (item) => renderBadgeIsVerified(item),
      truncateText: true,
    },
    {
      field: "name",
      name: "name",
      sortable: true,
      truncateText: true,
    },
    {
      field: "supportedServices",
      name: "Supported Services",
      render: (licenses) => {
        const maxVisibleLicenses = 3;
        if (licenses.length <= maxVisibleLicenses) {
          return licenses.map((license, index) => (
            <EuiBadge color={"#d83b01"} key={index}>
              {license}
            </EuiBadge>
          ));
        } else {
          const visibleLicenses = licenses
            .slice(0, maxVisibleLicenses)
            .map((license, index) => (
              <EuiBadge color={"#d83b01"} key={index}>
                {license}
              </EuiBadge>
            ));
          const moreBadge = (
            <EuiBadge
              color="gray"
              onClick={() => showModal(licenses)}
              key="more"
            >
              {`${licenses.length - maxVisibleLicenses} more...`}
            </EuiBadge>
          );
          return [...visibleLicenses, moreBadge];
        }
      },
      sortable: true,
      truncateText: true,
      width: "40%",
    },
  ];

  const search = {
    box: {
      incremental: true,
      schema: true,
    },
  };

  return (
    <Fragment>
      <DomainCreate props={props} closeModalProp={toggleIsClosed} />
      <EuiSpacer size="l" />
      <EuiInMemoryTable
        message={loading ? "Loading ..." : "No items found"}
        loading={loading}
        tableCaption="Domain List"
        items={domains}
        columns={columns}
        search={search}
        pagination={true}
        sorting={true}
      />
      {isModalVisible && renderModal()}
    </Fragment>
  );
};

export default DomainsTable;
